export default __webpack_public_path__ + "static/media/grafema_ummi_22.babd545a.jpg";